<script setup lang="ts">
import {
  NXGDSButton,
  NXGDSButtonVariants,
  NXGDSNotificationVariants,
} from '@nsftx/seven-nxg-design-system'
import { useBetslip } from '@nsftx/seven-client-retail-vue-sgp'
import { useSlipCheckStore } from '@/stores/slip-check/slipCheckStore'
import { useSlipRebet } from '@/composables/useSlipRebet/useSlipRebet'
import { handleSlipPayout } from '@/modules/slip-payout/slipPayoutService'
import { useNotificationsStore } from '@nsftx/seven-nxg-retail-vue-sdk'
import i18n from '@/plugins/translationsPlugin'
import { printSlipCopy } from '@/modules/slip-copy/slipCopyService'

const { t } = i18n.global

const slipCheckStore = useSlipCheckStore()
const { showNotification } = useNotificationsStore()
const {
  betslipId,
  bets,
  betIds,
  betslip,
  feBetslipId,
  betslipLinkCode,
  shouldShowCancelBetslip,
  shouldShowRebet,
  shouldShowPrintPayoutConfirmation,
  shouldShowPayout,
  betslipTotalPayout,
  betslipCurrency,
} = useBetslip()
const { rebetSlip } = useSlipRebet()

const handleCancelBetslip = async () => {
  try {
    // TODO: implement cancel ticket
  } catch {
    showNotification({
      variant: NXGDSNotificationVariants.error,
      text: [t('slip_cancel_ticket_failed')],
    })
  }
}

const handleRebet = async () => {
  const rebetSlipOptions = {
    linkCode: betslipLinkCode.value || '',
    feBetslipId: feBetslipId.value || '',
    betIds: betIds.value ?? [],
  }

  try {
    await rebetSlip(rebetSlipOptions)
    slipCheckStore.closeSlipCheckDetailsModal()
  } catch {
    showNotification({
      variant: NXGDSNotificationVariants.error,
      text: [t('slip_rebet_failed')],
    })
  }
}

const handlePrintPayoutConfirmation = async () => {
  try {
    // TODO: implement print payout confirmation
  } catch {
    showNotification({
      variant: NXGDSNotificationVariants.error,
      text: [t('slip_print_payout_confirmation_failed')],
    })
  }
}

const handlePrintCopy = async () => {
  if (!betslip.value) {
    return
  }

  await printSlipCopy(betslip.value)
  slipCheckStore.closeSlipCheckDetailsModal()
}

const handlePayout = async () => {
  try {
    if (betslipId.value && bets.value?.length) {
      await handleSlipPayout(betslipId.value, bets.value[0])
      slipCheckStore.closeSlipCheckDetailsModal()
    }
  } catch {
    showNotification({
      variant: NXGDSNotificationVariants.error,
      text: [t('slip_payout_failed')],
    })
  }
}
</script>

<template>
  <div class="ss-slip-details-modal__actions">
    <div class="ss-slip-details-modal__actions-buttons">
      <NXGDSButton
        v-if="shouldShowCancelBetslip"
        :variant="NXGDSButtonVariants.negative"
        @click="handleCancelBetslip"
      >
        {{ t('slip_cancel_ticket') }}
      </NXGDSButton>
      <NXGDSButton v-if="shouldShowRebet" @click="handleRebet">
        {{ t('common_rebet') }}
      </NXGDSButton>
    </div>
    <div class="ss-slip-details-modal__actions-buttons">
      <NXGDSButton v-if="shouldShowPrintPayoutConfirmation" @click="handlePrintPayoutConfirmation">
        {{ t('slip_print_payout_confirmation') }}
      </NXGDSButton>
      <NXGDSButton @click="handlePrintCopy">
        {{ t('slip_print_copy') }}
      </NXGDSButton>
      <NXGDSButton
        v-if="shouldShowPayout"
        :variant="NXGDSButtonVariants.primary"
        @click="handlePayout"
      >
        {{ t('slip_payout_betslip', { amount: betslipTotalPayout, currency: betslipCurrency }) }}
      </NXGDSButton>
    </div>
  </div>
</template>

<style lang="scss">
.ss-slip-details-modal {
  &__actions {
    display: flex;
    justify-content: space-between;

    &-buttons {
      display: flex;
      gap: var(--nxgds-alias-spacing-xs);
    }
  }
}
</style>
